const Container = ({children}) => {

  
  return (
    <div className="w-full max-w-[1550px] mx-auto">
      {children}
    </div>
  );
}

export default Container
